/*! Optimizer bootstrap: execução única, sem variáveis globais indefinidas. */
var script_loaded = false;
function loadJSscripts() {
  if (script_loaded) return;
  script_loaded = true;

  document.querySelectorAll('iframe.lazy[data-src]').forEach(function (frame) {
    var src = frame.getAttribute('data-src');
    if (src) {
      frame.src = src;
      frame.removeAttribute('data-src');
    }
  });

  document.querySelectorAll('script[data-src]').forEach(function (placeholder) {
    var src = placeholder.getAttribute('data-src');
    if (src) {
      placeholder.src = src;
      placeholder.removeAttribute('data-src');
    }
  });

  document.querySelectorAll('script[type="text/lazyload"]').forEach(function (placeholder) {
    var replacement = document.createElement('script');
    Array.prototype.forEach.call(placeholder.attributes, function (attribute) {
      if (attribute.name !== 'type') replacement.setAttribute(attribute.name, attribute.value);
    });
    replacement.type = 'text/javascript';
    replacement.text = placeholder.text || placeholder.textContent || '';
    placeholder.parentNode.replaceChild(replacement, placeholder);
  });

  document.querySelectorAll('link[data-href]').forEach(function (link) {
    var href = link.getAttribute('data-href');
    if (href) {
      link.href = href;
      link.removeAttribute('data-href');
    }
  });

  document.dispatchEvent(new CustomEvent('asyncLazyLoad'));
}

['pointerdown', 'keydown', 'touchstart', 'wheel'].forEach(function (eventName) {
  window.addEventListener(eventName, loadJSscripts, { passive: true, once: true });
});

window.addEventListener('load', function () {
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(loadJSscripts, { timeout: 2500 });
  } else {
    window.setTimeout(loadJSscripts, 1200);
  }
}, { once: true });

/*! SuperNutriOmni USA Customer First — V20 guardrails */
(function () {
  'use strict';

  if (String(window.SN_MARKET_HANDLE || '').toLowerCase() !== 'usa') return;

  var REGISTER_URL = 'https://portal.omnilife.com/registro-cliente?distributor_code=550126910AJ&country_code=USA&lang=en';
  var WHATSAPP_URL = 'https://wa.me/5532984697070?text=' + encodeURIComponent(
    'Hi Jorge! I need help with my Omnilife customer account or product information.'
  );

  function addStyles() {
    if (document.getElementById('sn-usa-customer-first-guardrails')) return;

    var style = document.createElement('style');
    style.id = 'sn-usa-customer-first-guardrails';
    style.textContent =
      '.botaoflutuante,' +
      '.product-item .parcelas-home,' +
      '.product-item .product-item__inventory,' +
      '.product-item .barradefundo,' +
      '.footer__aside-item--payment,' +
      '.cart-recap__secure-payment,' +
      '.cart-recap__wa,' +
      '.cart-recap__note,' +
      '.product-form__inventory,' +
      '.shopify-payment-button{display:none!important;}' +
      '.sn-us-customer-first-panel{margin:16px 0;padding:18px;border:1px solid rgba(107,33,168,.18);border-radius:14px;background:#faf7ff;}' +
      '.sn-us-customer-first-panel__eyebrow{margin:0 0 5px;font-size:12px;font-weight:800;letter-spacing:.05em;text-transform:uppercase;color:#6b21a8;}' +
      '.sn-us-customer-first-panel__title{margin:0 0 8px;font-size:20px;line-height:1.25;font-weight:800;color:#111827;}' +
      '.sn-us-customer-first-panel__text{margin:0 0 12px;line-height:1.55;color:#374151;}' +
      '.sn-us-customer-first-panel__btn{display:flex;align-items:center;justify-content:center;width:100%;min-height:50px;padding:12px 16px;border-radius:10px;background:#16a34a;color:#fff!important;text-decoration:none!important;font-weight:800;text-align:center;}' +
      '.sn-us-customer-first-panel__btn:hover{background:#15803d;}' +
      '.sn-us-customer-first-panel__actions{display:flex;gap:10px;flex-wrap:wrap;margin-top:10px;}' +
      '.sn-us-customer-first-panel__link{flex:1 1 190px;display:flex;align-items:center;justify-content:center;min-height:44px;padding:10px 12px;border:1px solid #e9d5ff;border-radius:10px;background:#fff;color:#6b21a8!important;text-decoration:none!important;font-weight:700;text-align:center;}' +
      '.sn-us-customer-first-panel__note{display:block;margin-top:10px;font-size:12.5px;line-height:1.45;color:#6b7280;}' +
      '@media(max-width:640px){.header__inner{column-gap:20px!important;}.sn-us-customer-first-panel__actions{display:block;}.sn-us-customer-first-panel__link{margin-top:8px;}}';

    document.head.appendChild(style);
  }

  function hideHeaderLegacyCommerce() {
    document.querySelectorAll('.header__action-item--account').forEach(function (el) {
      el.style.display = 'none';
    });

    document.querySelectorAll('.header-delivery-icon').forEach(function (icon) {
      var item = icon.closest ? icon.closest('.header__action-item') : null;
      if (item) item.style.display = 'none';
    });
  }

  function cleanFooter() {
    document.querySelectorAll('.bandeiras-align').forEach(function (flags) {
      var item = flags.closest ? flags.closest('.footer__aside-item') : flags;
      if (item) item.style.display = 'none';
    });

    document.querySelectorAll('.footer__aside-item p').forEach(function (p) {
      var text = (p.textContent || '').replace(/\s+/g, ' ').trim();
      if (text.indexOf('Prices and payment conditions are exclusive to purchases on this official website') === 0) {
        p.textContent = 'Product information and USD prices are provided for reference. Customer registration, payment, shipping and final order details are completed directly on Omnilife’s official U.S. platform.';
      }
    });
  }

  function getProductUrl(card) {
    if (!card || !card.querySelector) return '';
    var title = card.querySelector('.product-item__title[href]');
    if (title) return title.getAttribute('href') || '';
    var image = card.querySelector('.product-item__image-wrapper[href]');
    return image ? (image.getAttribute('href') || '') : '';
  }

  function makeLearnMore(linkOrButton, href) {
    if (!linkOrButton || !linkOrButton.parentNode || !href) return;

    var a = document.createElement('a');
    a.href = href;
    a.className = String(linkOrButton.className || '')
      .replace(/\bbutton--disabled\b/g, 'button--primary');
    a.textContent = 'Learn More';
    a.setAttribute('aria-label', 'Learn more about this product');
    linkOrButton.parentNode.replaceChild(a, linkOrButton);
  }

  function cleanProductCards(root) {
    root = root || document;

    if (!root.querySelectorAll) return;

    root.querySelectorAll('.product-item').forEach(function (card) {
      card.querySelectorAll('.parcelas-home,.product-item__inventory,.barradefundo').forEach(function (el) {
        el.style.display = 'none';
      });

      var href = getProductUrl(card);
      var actionList = card.querySelector('.product-item__action-list');
      if (!actionList || !href) return;

      actionList.querySelectorAll('button[data-action="add-to-cart"],button.button--disabled').forEach(function (button) {
        makeLearnMore(button, href);
      });
    });
  }

  function replaceExactText(root, oldText, newText) {
    if (!root || !root.querySelectorAll) return;

    root.querySelectorAll('h1,h2,h3,h4,h5,h6,p,span,strong,div').forEach(function (el) {
      if (el.children && el.children.length > 0) return;
      var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (text === oldText) el.textContent = newText;
    });
  }

  function cleanProductPage() {
    if (!document.body || !document.body.classList.contains('template-product')) return;

    document.querySelectorAll(
      '.product-form__payment-container [data-action="add-to-cart"],' +
      '.product-form__payment-container .button--disabled,' +
      '.product-form__payment-container .shopify-payment-button,' +
      '.product-form [data-action="add-to-cart"].product-form__add-button'
    ).forEach(function (el) {
      if (!el.classList.contains('sn-us-official-purchase')) el.style.display = 'none';
    });

    document.querySelectorAll('.product-form__inventory').forEach(function (el) {
      el.style.display = 'none';
    });

    var main = document.getElementById('main') || document;
    replaceExactText(main, 'Secure Payment', 'Official Omnilife Purchase');
    replaceExactText(main, 'PayPal', 'Preferred Customer');
    replaceExactText(
      main,
      'Secure PayPal payment with personalized WhatsApp assistance. Product availability, shipping and final order details are confirmed before payment.',
      'Register as a Preferred Customer and complete your purchase on Omnilife’s official U.S. platform. Payment, shipping options, taxes and final order details are provided directly by Omnilife during checkout.'
    );

    if (document.querySelector('.sn-us-official-purchase,.sn-us-customer-first-product-fallback')) return;

    var host =
      document.querySelector('.product-form__payment-container') ||
      document.querySelector('.product-form') ||
      document.querySelector('.product-meta');

    if (!host) return;

    var panel = document.createElement('div');
    panel.className = 'sn-us-customer-first-panel sn-us-customer-first-product-fallback';
    panel.innerHTML =
      '<p class="sn-us-customer-first-panel__eyebrow">Official Omnilife purchase</p>' +
      '<h3 class="sn-us-customer-first-panel__title">Buy directly from Omnilife</h3>' +
      '<p class="sn-us-customer-first-panel__text">Create your free Preferred Customer account and complete your purchase on Omnilife’s official U.S. platform.</p>' +
      '<a class="sn-us-customer-first-panel__btn" href="' + REGISTER_URL + '" target="_blank" rel="noopener">Register as a Preferred Customer — Free</a>' +
      '<div class="sn-us-customer-first-panel__actions">' +
        '<a class="sn-us-customer-first-panel__link" href="' + WHATSAPP_URL + '" target="_blank" rel="noopener">Ask Jorge for Help</a>' +
      '</div>' +
      '<small class="sn-us-customer-first-panel__note">Payment, shipping options, taxes, final availability and order details are provided directly by Omnilife during checkout.</small>';

    host.insertBefore(panel, host.firstChild);
  }

  function cleanCart() {
    if (!document.body || !document.body.classList.contains('template-cart')) return;

    document.querySelectorAll('.sn-cart-cta,.cart-recap__checkout,.cart-recap__secure-payment,.cart-recap__wa,.cart-recap__note').forEach(function (el) {
      el.style.display = 'none';
    });

    var notice = document.querySelector('.cart-recap__notices');
    if (notice) {
      notice.innerHTML = '<p>Products selected here are a reference only. Shipping, taxes, final availability and the final order total are confirmed directly on Omnilife’s official U.S. platform.</p>';
    }

    document.querySelectorAll('.cart-recap__price-line-label').forEach(function (el) {
      var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (text === 'Total') el.textContent = 'Reference total';
    });

    if (document.querySelector('.sn-us-customer-first-cart')) return;

    var host =
      document.querySelector('.cart .card__section') ||
      document.querySelector('.cart-recap__scroller .card__section');

    if (!host) return;

    var panel = document.createElement('div');
    panel.className = 'sn-us-customer-first-panel sn-us-customer-first-cart';
    panel.innerHTML =
      '<p class="sn-us-customer-first-panel__eyebrow">Preferred Customer</p>' +
      '<h2 class="sn-us-customer-first-panel__title">Complete your purchase with Omnilife</h2>' +
      '<p class="sn-us-customer-first-panel__text">Your selections on SuperNutriOmni do not transfer automatically to Omnilife. Create your free Preferred Customer account, select the products again on Omnilife’s official platform and review the final total before confirming your purchase.</p>' +
      '<a class="sn-us-customer-first-panel__btn" href="' + REGISTER_URL + '" target="_blank" rel="noopener">Register as a Preferred Customer — Free</a>' +
      '<div class="sn-us-customer-first-panel__actions">' +
        '<a class="sn-us-customer-first-panel__link" href="/en-us/collections/all-omnilife-supplements">Continue Browsing</a>' +
        '<a class="sn-us-customer-first-panel__link" href="' + WHATSAPP_URL + '" target="_blank" rel="noopener">Need Help? Talk to Jorge</a>' +
      '</div>' +
      '<small class="sn-us-customer-first-panel__note">Customer registration, payment, shipping and order fulfillment are completed directly through Omnilife.</small>';

    var form = host.querySelector('form[action*="/cart"]');
    if (form) host.insertBefore(panel, form);
    else host.appendChild(panel);
  }

  function run() {
    addStyles();
    hideHeaderLegacyCommerce();
    cleanFooter();
    cleanProductCards(document);
    cleanProductPage();
    cleanCart();
  }

  function scheduleRun() {
    if (scheduleRun.pending) return;
    scheduleRun.pending = true;
    window.requestAnimationFrame(function () {
      scheduleRun.pending = false;
      run();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  try {
    var observer = new MutationObserver(function () {
      scheduleRun();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(function () {
      try { observer.disconnect(); } catch (e) {}
    }, 10000);
  } catch (e) {}

  document.addEventListener('click', function (event) {
    var target = event.target && event.target.closest
      ? event.target.closest('[data-action="add-to-cart"]')
      : null;

    if (!target) return;

    var card = target.closest ? target.closest('.product-item') : null;
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();

    if (card) {
      var href = getProductUrl(card);
      if (href) window.location.href = href;
      return;
    }

    window.open(REGISTER_URL, '_blank', 'noopener');
  }, true);
})();